import { render, staticRenderFns } from "./RegisterPage1.vue?vue&type=template&id=cd6f7410&scoped=true&"
import script from "./RegisterPage1.vue?vue&type=script&lang=js&"
export * from "./RegisterPage1.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPage1.vue?vue&type=style&index=0&id=cd6f7410&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6f7410",
  null
  
)

export default component.exports